import {Component, HostBinding, Input} from '@angular/core';
import {environment} from '../environments/environment';
import {LocalizationService} from './shared/services/localization.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    standalone: false,
    styleUrl: './app.component.scss'
})
export class AppComponent {
    title = 'smart-assistant';
    @HostBinding('class.smart-assistant') default = true;
    @Input() lang: string | undefined;
    
    constructor(private localizationService: LocalizationService) {
        console.log(environment);
        this.localizationService.setLanguage(this.lang);
    }
}
